var skivy71 = require('./skivy71')
var smartkx = require('./smartkx')

module.exports = { skivy71, smartkx }